import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { MisFacturasPage } from "@/features/mis-facturas/components/MisFacturasPage";
import { misFacturasQueryOptions } from "@/features/mis-facturas/hooks/use-mis-facturas";

/**
 * Ruta `/facturas` · "Mis facturas" (P30): acuses de validación de los CFDIs
 * del solicitante actual. Loader precarga el listado sin filtros.
 */
export const Route = createFileRoute("/_authed-tw/facturas")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(misFacturasQueryOptions()),
  component: () => (
    <PermissionGate permisos={[PERMISOS.facturasVer]}>
      <MisFacturasPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
